import VueCqrs from '@cqrs/vue-component-cqrs';
import * as c from '@Criteria/WeightedScores/Domain/commands-core';
import Component from 'vue-class-component';

@Component
export default class WeightedScoresCommands extends VueCqrs {

	invokeCreateWeightedScoreCommandV1(workspaceId: number, scoreId: string, chId: number, weightsSetId: number, criterionId: number, name: string, desc: string)
	{
		const cmd = new c.CreateWeightedScoreCommandV1(workspaceId, scoreId, chId, weightsSetId, criterionId, name, desc);
		this.$command(cmd, scoreId);
	}

	invokeUpdateWeightedScoreCommandV1(workspaceId: number, scoreId: string, weightsSetId: number, criterionId: number, name: string, desc: string)
	{
		const cmd = new c.UpdateWeightedScoreCommandV1(workspaceId, scoreId, weightsSetId, criterionId, name, desc);
		this.$command(cmd, scoreId);
	}
}
